const hotels = {
  back: "Costas", // translated
  rooms: "quartos", // translated
  viewPictures: "Ver fotos", // translated
  showMore: "mostre mais", // translated
  bookingInformation: "Informações de reserva", // translated
  cancellationPolicy: "Política de cancelamento", // translated
  from: "A partir de", // translated
  to: "para", // translated
  cancellationIs: "cancelamento é", // translated
  free: "gratuitamente", // translated
  chargeableWithFeeOf: "cobrado com uma taxa de", // translated
  prebook: "Pré-livro", // translated
  guests: "Convidados", // translated
  payment: "Pagamento", // translated
  byClicking: "Clicando", // translated
  next: "Próximo", // translated
  youAreAgreeingToOur: "você está concordando com o nosso", // translated
  termsAndConditions: "Termos e Condições", // translated
  previous: "Anterior", // translated
  cancel: "Cancelar", // translated
  mealPlan: "Plano de refeição", // translated
  roomType: "Tipo de sala", // translated
  description: "Descrição", // translated
  readLess: "Leia menos", // translated
  readMore: "consulte Mais informação", // translated
  facilities: "Instalações", // translated
  viewLess: "Ver menos", // translated
  viewMore: "Veja mais", // translated
  less: "menos", // translated
  more: "mais", // translated
  notAvailable_short: "N / D", // translated
  backToHotelList: "Voltar à lista de hotéis", // translated
  viewOnMap: "Ver no mapa", // translated
  sleeps: "Dorme", // translated
  adults: "Adultos", // translated
  yearsOld: "anos", // translated
  type: "Tipo", // translated
  bedding: "Roupa de cama", // translated
  selectRoom: "Selecionar quarto", // translated
  city: "Cidade", // translated
  checkIn: "Check-in", // translated
  checkOut: "Verificação de saída", // translated
  date: "Encontro", // translated
  persons: "Pessoas", // translated
  stillOnTrialQuestionToUpgrade: "Ops! Parece que você ainda está em uma assinatura de avaliação. Você precisa ser um membro confirmado para fazer reservas. Gostaria de atualizar agora?", // translated
  stillOnTrialQuestionToUpgradeNonElligib: "Ops! Parece que você ainda não está inscrito. Você precisa ser um membro confirmado para fazer reservas. Gostaria de atualizar agora?", // translated
  completeProfile: "Por favor, preencha seu perfil de usuário primeiro", // translated
  upgrade: "Melhoria", // translated
  close: "Perto", // translated
  viewDetails: "Ver detalhes", // translated
  name: "Nome", // translated
  rating: "Avaliação", // translated
  budget: "Orçamento", // translated
  orderBy: "Ordenar por", // translated
  priceLowestFirst: "Preço: mais baixos primeiro)", // translated
  priceHighestFirst: "Preço: Mais caro primeiro)", // translated
  ratingLowestFirst: "Classificação (menor primeiro)", // translated
  ratingHighestFirst: "Classificação (maior primeiro)", // translated
  starRatingAndPrice: "Classificação por estrelas e preço", // translated
  select: "Selecionar", // translated
  reset: "Redefinir", // translated
  apply: "Aplicar", // translated
  filterBy: "Filtrar por", // translated
  myProfile: "Meu perfil", // translated
  login: "Conecte-se", // translated
  roomOnly: "Apenas quarto", // translated
  bedAndBreakfast: "Alojamento e pequeno-almoço", // translated
  halfBoard: "Meia pensão", // translated
  fullBoard: "Pensão completa", // translated
  allInclusive: "Tudo Incluído", // translated
  filter: "Filtro", // translated
  mapView: "Visão do mapa", // translated
  results: "resultados", // translated
  listView: "Exibição de lista", // translated
  newSearch: "Nova pesquisa", // translated
  editSearch: "Editar pesquisa", // translated
  all: "Tudo", // translated
  multiple: "Múltiplo", // translated
  editProfile: "Editar Perfil", // translated
  backToHotelsList: "Voltar à lista de hotéis", // translated
  roomName: "Nome da sala", // translated
  mealType: "Tipo de refeição", // translated
  freeCancellation: "Cancelamento grátis", // translated
  yes: "Sim", // translated
  no: "Não", // translated
  filters: "Filtros", // translated
  cancellationNonRefundable: "O cancelamento não é reembolsável", // translated
  hotel: "Hotel", // translated
  any: "Qualquer", // translated
  performNewSearch: "Faça uma nova pesquisa", // translated
  biggestSavingsFirst: "Maiores economias primeiro", // translated
  hotels: "Hotéis", // translated
  dates: "datas", // translated
  selectRooms: "Selecione quartos", // translated
  accommodation: "Alojamento", // translated
  off: "Desligado", // translated
  hotelRating: "Classificação do hotel", // translated
};


export default hotels;
